export enum LinkListStateEnum {
    SHOW_FIRST,
    HIDDEN,
    SHOW_ALL
}
